import React from "react";

// ===== LOGOUT CONFIRMATION MODAL =====
const LogoutModal = ({ show, theme, isMobile, isRTL, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(10px)",
        padding: isMobile ? "20px" : "40px",
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: theme === "light"
            ? "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 250, 251, 0.98) 100%)"
            : "linear-gradient(135deg, rgba(30, 41, 59, 0.98) 0%, rgba(15, 23, 42, 0.98) 100%)",
          border: theme === "light"
            ? "2px solid rgba(226, 232, 240, 0.8)"
            : "2px solid rgba(71, 85, 105, 0.4)",
          borderRadius: isMobile ? "20px" : "28px",
          padding: isMobile ? "24px" : "40px",
          maxWidth: "600px",
          width: "100%",
          backdropFilter: "blur(24px)",
          boxShadow: theme === "light"
            ? "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
            : "0 25px 50px -12px rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: "flex",
          gap: "12px",
          justifyContent: "center",
          flexDirection: isMobile ? "column" : "row",
        }}>
          <button
            onClick={onConfirm}
            style={{
              background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
              color: "white",
              border: "none",
              borderRadius: "14px",
              padding: isMobile ? "14px 28px" : "12px 32px",
              fontWeight: "700",
              fontSize: isMobile ? "15px" : "16px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              flex: isMobile ? "none" : 1,
            }}
          >
            {isRTL ? "تسجيل الخروج" : "Confirm Logout"}
          </button>

          <button
            onClick={onCancel}
            style={{
              background: theme === "light"
                ? "rgba(226, 232, 240, 0.8)"
                : "rgba(71, 85, 105, 0.5)",
              color: theme === "light" ? "#1e293b" : "#ffffff",
              border: "none",
              borderRadius: "14px",
              padding: isMobile ? "14px 28px" : "12px 32px",
              fontWeight: "700",
              fontSize: isMobile ? "15px" : "16px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              flex: isMobile ? "none" : 1,
            }}
          >
            {isRTL ? "إلغاء" : "Cancel"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
